import CodingDev6 from '@/images/roles/leonardo.webp';
import CodingDev7 from '@/images/roles/maria.webp';
import CodingDev9 from '@/images/roles/raj.webp';
import CodingDev8 from '@/images/roles/sofia.webp';

// const reactLogo = "https://cdn.simpleicons.org/react/61DAFB";
// const vueLogo = "https://cdn.simpleicons.org/vuedotjs/42b883";
const angularLogo = 'https://cdn.simpleicons.org/angular/DD0031';

const pythonLogo = 'https://cdn.simpleicons.org/python/3776AB';
const springLogo = 'https://cdn.simpleicons.org/spring/6DB33F';

const mysqlLogo = 'https://cdn.simpleicons.org/mysql/005C84';
const postgresLogo = 'https://cdn.simpleicons.org/postgresql/4169E1';

const figmaLogo = 'https://cdn.simpleicons.org/figma/F24E1E';
const sketchLogo = 'https://cdn.simpleicons.org/sketch';
const lucidLogo = 'https://cdn.simpleicons.org/lucid';

const jiraLogo = 'https://cdn.simpleicons.org/atlassian/0052CC';
const trelloLogo = 'https://cdn.simpleicons.org/trello/0052CC';

//
export const cards = [
	{
		name: 'Leonardo',
		position: 'Tech Lead - Senior Java Developer',
		country: 'UNITED STATES',
		videoUrl: null,
		skills: [
			'Java (SE & EE)',
			'Angular',
			'AJAX',
			'Oracle',
			'MySql',
			'Redis',
			'jQuery',
			'...',
		],

		skillsIcon: [angularLogo, springLogo, mysqlLogo],
		thumbnail: CodingDev6,
	},

	{
		name: 'Maria',
		position: 'Product Manager - Agile Coach',
		country: 'CANADA',
		videoUrl: null,
		skills: [
			'Agile methodologies',
			'Scrum',
			'Kanban',
			'JIRA',
			'Trello',
			'User experience',
			'...',
		],

		skillsIcon: [jiraLogo, trelloLogo, figmaLogo],
		thumbnail: CodingDev7,
	},

	{
		name: 'Sofia',
		position: 'UX Designer - Visual Artist',
		country: 'UNITED KINGDOM',
		videoUrl: null,
		skills: [
			'User research',
			'Wireframing',
			'Prototyping',
			'Adobe XD',
			'Sketch',
			'Figma',
			'InVision',
			'...',
		],

		skillsIcon: [figmaLogo, sketchLogo, lucidLogo],
		thumbnail: CodingDev8,
	},

	{
		name: 'Raj',
		position: 'Data Scientist - Machine Learning Engineer',
		country: 'INDIA',
		videoUrl: null,
		skills: [
			'Python',
			'R',
			'TensorFlow',
			'Pandas',
			'SQL',
			'Data visualization',
			'Statistics',
			'...',
		],

		skillsIcon: [pythonLogo, postgresLogo, mysqlLogo],
		thumbnail: CodingDev9,
	},
];
// data for HumanVettingProcess
export const steps = [
	{
		title: 'Profile & Background Screening',
		description:
			"We start by reviewing a candidate's CV, LinkedIn, and portfolio in detail. We verify work history, references, and project experience to confirm credibility before moving forward.",
	},
	{
		title: 'Automated Pre-Screening (AI + HR Review)',
		description:
			'Our Cleos AI assistant quickly analyzes profiles for skills, tech stack, and match potential. Every AI recommendation is double-checked by our HR specialists to eliminate false positives.',
	},
	{
		title: 'Soft Skills & Communication Check',
		description:
			'Candidates complete a live interview with our HR team to assess English fluency, professionalism, and communication style. We only move forward with people who can collaborate effectively in remote, international teams.',
	},
	{
		title: 'Technical Evaluation',
		description:
			'We run technical interviews and coding challenges led by senior engineers. These tests measure not only problem-solving skills but also code quality, scalability, and adherence to best practices.',
	},
	{
		title: 'Continuous Quality Monitoring',
		description:
			'Even after onboarding, we collect client feedback and track performance. Underperforming talent is removed, ensuring only reliable professionals stay in the ecosystem.',
	},
];
